/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type CreateTopUpResponse = {
    payment_id: string;
    provider: string;
    amount_credits: number;
    status: CreateTopUpResponse.status;
    checkout_url: string;
    pay_address?: string | null;
    pay_amount?: string | null;
    pay_currency?: string | null;
    expires_at?: string | null;
};
export namespace CreateTopUpResponse {
    export enum status {
        PROCESSING = 'PROCESSING',
    }
}

